import "core-js/modules/es.array.push.js";
import axios from "axios";
import { inject, ref, computed } from "vue";
import * as turf from "@turf/turf";
import emitter from "@/store/eventBus.js";
import { mapActions, mapMutations, mapState, useStore } from "vuex";
import EpInfoFilled from "~icons/ep/info-filled";
import LineMdConfirm from "~icons/line-md/confirm";
export default {
  data() {
    let currentDate = new Date();
    let data1 = new Date();
    let data2 = new Date();
    let data3 = new Date();
    let data4 = new Date();
    let data5 = new Date();
    data1.setDate(currentDate.getDate());
    data2.setDate(currentDate.getDate() + 1);
    data3.setDate(currentDate.getDate() + 2);
    data4.setDate(currentDate.getDate() + 3);
    data5.setDate(currentDate.getDate() + 4);
    let month1 = data1.getMonth() + 1;
    let month2 = data2.getMonth() + 1;
    let month3 = data3.getMonth() + 1;
    let month4 = data4.getMonth() + 1;
    let month5 = data5.getMonth() + 1;
    data1 = data1 < 10 ? "0" + data1.getDate() : data1.getDate();
    data2 = data2 < 10 ? "0" + data2.getDate() : data2.getDate();
    data3 = data3 < 10 ? "0" + data3.getDate() : data3.getDate();
    data4 = data4 < 10 ? "0" + data4.getDate() : data4.getDate();
    data5 = data5 < 10 ? "0" + data5.getDate() : data5.getDate();
    month1 = month1 < 10 ? "0" + month1 : month1;
    month2 = month2 < 10 ? "0" + month2 : month2;
    month3 = month3 < 10 ? "0" + month3 : month3;
    month4 = month4 < 10 ? "0" + month4 : month4;
    month5 = month5 < 10 ? "0" + month5 : month5;
    return {
      input: "",
      dialogVisible: false,
      tab: "tab_1",
      addAddress: false,
      paths: [{
        name: "Оформление заказа",
        path: "/rol-shop/order"
      }],
      loadingPostAddress: false,
      restaurants: [],
      optionsDay: [{
        value: `${data1}.${month1}`,
        label: "Сегодня"
      }, {
        value: `${data2}.${month2}`,
        label: "Завтра"
      }, {
        value: `${data3}.${month3}`,
        label: `${data3}.${month3}`
      }, {
        value: `${data4}.${month4}`,
        label: `${data4}.${month4}`
      }, {
        value: `${data5}.${month5}`,
        label: `${data5}.${month5}`
      }],
      optionsTime: [],
      selectDay: "",
      selectTime: "",
      lat: "",
      long: "",
      svg: `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0); stroke: #f63"/>
      `,
      paymentDelivery: "Наличными курьеру",
      paymentPickup: "Наличными в точке выдачи",
      sliderLoading: false,
      validForm1: false,
      validForm2: false,
      validForm3: false,
      isCreatingOrder: false,
      orderId: null,
      animals: ["dog"],
      doorOptions1: ["Оставить под дверью"],
      doorOptions2: ["Оставить под дверью"],
      addressRadio: "",
      cityRadio1: "Киев",
      cityRadio2: "Киев",
      resultsOrder: "",
      coord: this.$store.state.map.coord,
      result: [],
      orderDone: false,
      idAddress: "",
      EpInfoFilled: EpInfoFilled
    };
  },
  components: {
    LineMdConfirm
  },
  methods: {
    ...mapActions({
      checkAddress: "map/checkAddress"
    }),
    ...mapMutations({
      setPaths: "crumbs/setPaths"
    }),
    async fetchAddressSelect(value, cb) {
      try {
        if (value) {
          const {
            data
          } = await axios.get(`https://suggest-maps.yandex.ru/v1/suggest?apikey=00748542-2e0b-439d-864b-98b4baac2c5f&text=${this.cityRadio1}, ${value}&bbox=${this.area}&lang=ru_RU&strict_bounds=1&types=street,metro,house,district,vegetation&print_address=1`);
          if (data.results) {
            this.result = data.results.map(item => ({
              address: item.title.text,
              house: item.address.component.find(pl => pl.kind == "HOUSE") ? item.address.component.find(pl => pl.kind == "HOUSE").name : ""
            }));

            // возвращение данных
            cb(this.result);
          } else {
            // если нет результатов / скрытие списка
            cb([]);
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleSelectAddress(item) {
      // заполнение полей
      this.form.address = item.address;
      this.form.house = item.house;

      // проверка что адрес был выбран из списка
      this.checkFromSelect = true;
    },
    async fetchAddress() {
      let apiRes = null;
      try {
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/address`);
        this.address = data;

        // по умолчанию первый отмечен
        if (this.address.length > 0) {
          this.addressRadio = this.address[0].id;
        }
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.$router.push("/rol-shop/404");
        }
      }
    },
    async fetchRestaurant() {
      try {
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/restaurant?city=${this.cityRadio2}`);
        this.restaurants = data;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchProduct() {
      let apiRes = null;
      try {
        this.sliderLoading = true;
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/items?category=drinks`);
        this.products = data.map(obj => ({
          ...obj,
          isAdded: false,
          count: 1
        }));
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        this.sliderLoading = false;
        if (apiRes == 404) {
          this.$router.push("/rol-shop/404");
        }
      }
    },
    geocoderCoord(lat, long) {
      this.lat = lat;
      this.long = long;

      // скрытие блока при клике по карте
      this.$store.commit("map/setDeliveryCheck", false);
    },
    async removeAddress() {
      await axios.delete(`https://c2ff7a8de0a119c8.mokky.dev/address/${this.addressRadio}`);
      let index = this.address.findIndex(item => item.id == this.addressRadio);
      if (index !== -1) {
        this.address.splice(index, 1);
      }

      // первый адрес отмечен
      if (this.address.length > 0) {
        this.addressRadio = this.address[0].id;
      }
    },
    sumbitForm(forName) {
      forName.validate(valid => {
        if (valid) {
          this.postAddress().then(() => {
            this.addAddress = false;
            this.fetchAddress();
          });
        } else {
          return false;
        }
      });
    },
    async postAddress() {
      try {
        this.loadingPostAddress = true;
        if (!this.repeatAddress(this.form.address, this.form.house, this.form.input, this.form.floor, this.form.apartment, this.cityRadio1)) {
          const {
            data
          } = await axios.post(`https://c2ff7a8de0a119c8.mokky.dev/address`, {
            address: this.form.address,
            house: this.form.house,
            input: this.form.input,
            floor: this.form.floor,
            apartment: this.form.apartment,
            city: this.cityRadio1
          });
        }
        this.form.address = "";
        this.form.house = "";
        this.form.input = "";
        this.form.floor = "";
        this.form.apartment = "";
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingPostAddress = false;
      }
    },
    filterArray(input, cb) {
      const results = this.restaurants.filter(element => element.address.toLowerCase().includes(input.toLowerCase()));
      cb(results);
    },
    handleSelect(item) {
      // ресторан из списка
      this.fromSelectRestaurant = true;
      this.form.restaurant = item.address;
    },
    async validForms() {
      if (!this.ruleFormRef3) return;
      await this.ruleFormRef3.validate((valid, fields) => {
        if (valid) {
          this.validForm1 = true;
        }
      });
      if (this.tab === "tab_2") {
        await this.ruleFormRef2.validate((valid, fields) => {
          if (valid) {
            this.validForm2 = true;
          }
        });
      }
      if (this.tab === "tab_1" && (this.addAddress || this.address.length === 0)) {
        await this.ruleFormRef1.validate((valid, fields) => {
          if (valid) {
            this.validForm3 = true;
          }
        });
      }
    },
    generateTimeOptions() {
      this.optionsTime = [];
      if (this.selectDay === this.optionsDay[0].value) {
        let currentDate = new Date();
        let hours = currentDate.getHours();
        let minutes = currentDate.getMinutes();
        this.optionsTime.push({
          value: `${hours}:${minutes}`,
          label: "Ближайшее"
        });
        if (minutes > 30) {
          this.optionsTime.push({
            value: `${hours + 2}:30`,
            label: `${hours + 2}:30`
          });
          for (let i = hours + 3; i < 23; i++) {
            this.optionsTime.push({
              value: `${i}:00`,
              label: `${i}:00`
            });
            this.optionsTime.push({
              value: `${i}:30`,
              label: `${i}:30`
            });
          }
        } else {
          for (let i = hours + 2; i < 23; i++) {
            this.optionsTime.push({
              value: `${i}:00`,
              label: `${i}:00`
            });
            this.optionsTime.push({
              value: `${i}:30`,
              label: `${i}:30`
            });
          }
        }
      } else {
        for (let i = 11; i < 23; i++) {
          this.optionsTime.push({
            value: `${i}:00`,
            label: `${i}:00`
          });
          this.optionsTime.push({
            value: `${i}:30`,
            label: `${i}:30`
          });
        }
      }
      this.selectTime = this.optionsTime[0].value;
    },
    postOrder() {
      this.validForms().then(() => {
        if (this.tab === "tab_2") {
          //самовывоз
          if (this.validForm1 && this.validForm2) {
            this.createOrder();
          }
        } else if (this.tab === "tab_1" && (this.addAddress || this.address.length === 0)) {
          // доставка и добавить
          if (this.validForm1 && this.validForm3) {
            this.createOrder();
          }
        } else {
          // доставка и сохраненный адрес
          if (this.validForm1) {
            this.createOrder();
          }
        }
      });
    },
    async createOrder() {
      try {
        this.isCreatingOrder = true;
        const info = {
          name: this.form.name,
          tel: this.form.tel,
          day: this.selectDay,
          time: this.selectTime,
          year: new Date().getFullYear(),
          payment: this.tab === "tab_1" ? this.paymentDelivery : this.paymentPickup,
          items: this.cart,
          totalPrice: this.totalPrice,
          animals: this.animals,
          methods: this.tab === "tab_1" ? "Доставка" : "Самовывоз",
          address: "",
          options: "",
          number: "",
          status: 0
        };

        // сдача
        if (this.paymentDelivery === "Наличными курьеру" && this.tab === "tab_1" || this.paymentPickup === "Наличными в точке выдачи" && this.tab === "tab_2") {
          info.change = this.form.change ? this.form.change : "без сдачи";
        }
        if (this.form.comment1) {
          info.regularSticks = this.form.comment1;
        }
        if (this.form.comment2) {
          info.traningSticks = this.form.comment2;
        }
        if (this.form.note) {
          info.note = this.form.note;
        }
        if (this.freeProduct.length > 0) {
          info.freeProduct = this.freeProduct;
        }
        if (this.tab === "tab_1" && !this.addAddress && this.address.length > 0) {
          const result = this.address.find(item => {
            return item.id === this.addressRadio;
          });
          info.address = result;
          info.options = this.doorOptions1;
        }
        if (this.tab === "tab_1" && (this.addAddress || this.address.length === 0)) {
          const result = {
            city: this.cityRadio1,
            address: this.form.address,
            house: this.form.house,
            input: this.form.input,
            floor: this.form.floor,
            apartment: this.form.apartment
          };
          info.address = result;
          info.options = this.doorOptions2;
        }
        if (this.tab === "tab_2") {
          const result = {
            city: this.cityRadio2,
            address: this.form.restaurant
          };
          info.address = result;
        }

        // история заказов в localStorage
        this.historyOrder = Number(this.historyOrder) + 1;
        localStorage.setItem("order", JSON.stringify(this.historyOrder));
        info.number = this.historyOrder;
        const {
          data
        } = await axios.post(`https://c2ff7a8de0a119c8.mokky.dev/orders`, info);
        this.cart = [];
      } catch (err) {
        console.log(err);
      } finally {
        this.isCreatingOrder = false;
        this.orderDone = true;
      }
    },
    async fetchOrder(number) {
      let apiRes = null;
      try {
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/orders?number=${number}`);
        this.resultsOrder = data[0];
        this.cart = this.resultsOrder.items;
      } catch (err) {
        if (err.response) {
          apiRes = err.response.status;
        }
      } finally {
        if (apiRes == 404) {
          this.$router.push("/rol-shop/404");
        }
      }
    },
    onRepeatOrder(number) {
      this.fetchOrder(number).then(() => {
        // включение кнопки для карточек и слайдера и favorites
        // this.sushi = this.updateItemsStatus(this.sushi);
        // this.rolls = this.updateItemsStatus(this.rolls);
        // this.sets = this.updateItemsStatus(this.sets);
        // this.snacks = this.updateItemsStatus(this.snacks);
        // this.drinks = this.updateItemsStatus(this.drinks);
        // this.slides = this.updateItemsStatus(this.slides);
        // this.favorites = this.updateItemsStatus(this.favorites);
        // this.categores = this.updateItemsStatus(this.categores);
        // this.slidesTovar = this.updateItemsStatus(this.slidesTovar);
        this.products = this.updateItemsStatus(this.products);
        // this.cart.some((cartItem) => cartItem.id === this.product.id)
        //   ? (this.product.isAdded = true)
        //   : null;

        // заполнение полей
        this.form.name = this.resultsOrder.name;
        this.form.tel = this.resultsOrder.tel;
        this.form.change = this.resultsOrder.change !== "без сдачи" ? this.resultsOrder.change : "";
        this.animals = this.resultsOrder.animals;
        if (this.resultsOrder.methods === "Доставка") {
          this.tab = "tab_1";
          this.paymentDelivery = this.resultsOrder.payment;
          if (this.repeatAddress(
          //если адрес есть в сохраненных
          this.resultsOrder.address.address, this.resultsOrder.address.house, this.resultsOrder.address.input, this.resultsOrder.address.floor, this.resultsOrder.address.apartment, this.resultsOrder.address.city)) {
            this.addressRadio = this.idAddress;
            this.doorOptions1 = this.resultsOrder.options;
          } else {
            // не сохраненный адрес
            this.addAddress = true;
            this.cityRadio1 = this.resultsOrder.address.city;
            this.form.address = this.resultsOrder.address.address;
            this.form.house = this.resultsOrder.address.house;
            this.form.input = this.resultsOrder.address.input;
            this.form.floor = this.resultsOrder.address.floor;
            this.form.apartment = this.resultsOrder.address.apartment;
            this.doorOptions2 = this.resultsOrder.options;
          }
        }
        if (this.resultsOrder.methods === "Самовывоз") {
          this.tab = "tab_2";
          this.paymentPickup = this.resultsOrder.payment;
          this.cityRadio2 = this.resultsOrder.address.city;
          this.form.restaurant = this.resultsOrder.address.address;
          this.fetchRestaurant();
        }
        if (this.resultsOrder.regularSticks) {
          this.form.comment1 = this.resultsOrder.regularSticks;
        }
        if (this.resultsOrder.traningSticks) {
          this.form.comment2 = this.resultsOrder.traningSticks;
        }
        if (this.resultsOrder.note) {
          this.form.note = this.resultsOrder.note;
        }
      });
    },
    updateItemsStatus(items) {
      return items.map(item => ({
        ...item,
        isAdded: this.cart.some(cartItem => cartItem.id === item.id)
      }));
    },
    repeatAddress(address, house, input, floor, apartment, city) {
      for (let item of this.address) {
        if (item.address === address && item.house === house && item.input === input && item.floor === floor && item.apartment === apartment && item.city === city) {
          this.idAddress = item.id;
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    // значения по умолчанию
    this.selectDay = this.optionsDay[0].value;
    // генерация времени
    this.generateTimeOptions();
    // координаты центра по умолчанию
    this.lat = this.coord[0];
    this.long = this.coord[1];
    // slider
    this.fetchProduct().then(() => {
      this.products = this.products.map(item => ({
        ...item,
        isAdded: this.cart.some(cartItem => cartItem.id === item.id)
      }));
    });

    // прослушивание событие с корзины
    // emitter.on("is-order-fetching", this.onRepeatOrder);

    // если есть параметр repeat повтор заказа
    if (this.$route.query.repeat) {
      this.fetchAddress().then(() => {
        const number = this.$route.query.repeat;
        this.onRepeatOrder(number);
      });
    } else {
      this.fetchAddress();
    }
  },
  computed: {
    ...mapState({
      deliveryPossible: state => state.map.deliveryPossible,
      deliveryCheck: state => state.map.deliveryCheck,
      addressDialog: state => state.map.address,
      loadingDeliveryCheck: state => state.map.loading,
      loadingAddress: state => state.map.loadingAddress
    }),
    checkCart() {
      return this.cart.length === 0;
    },
    repeatOnPage() {
      return Object.prototype.hasOwnProperty.call(this.$route.query, "repeat");
    }
  },
  watch: {
    repeatOnPage(value) {
      // если повтор заказа был сделан когда страница уже была открыта
      if (value) {
        const number = this.$route.query.repeat;
        this.onRepeatOrder(number);
      }
    },
    checkCart(value) {
      if (value) {
        if (!this.orderDone) {
          // удаление query из запроса если нет товаров в корзине
          this.$router.push({
            path: "/rol-shop/order"
          });
        } else {
          this.$router.push({
            path: "/rol-shop/success"
          });
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setPaths(vm.paths);
    });
  },
  setup(props) {
    const {
      address,
      area
    } = inject("address");
    const {
      cart,
      addToCart,
      removeFromCart,
      totalPrice,
      historyOrder
    } = inject("cart");
    const {
      sushi,
      rolls,
      sets,
      snacks,
      drinks,
      slides,
      favorites,
      categores,
      product,
      slidesTovar,
      products
    } = inject("items");
    const form = ref({
      name: "",
      tel: "",
      address: "",
      house: "",
      input: "",
      floor: "",
      apartment: "",
      restaurant: "",
      comment1: "",
      comment2: "",
      note: "",
      change: "",
      code: ""
    });
    const ruleFormRef1 = ref({});
    const ruleFormRef2 = ref({});
    const ruleFormRef3 = ref({});
    const ruleFormRef4 = ref({});
    const ruleFormRef5 = ref({});
    const ruleFormRef6 = ref({});
    const ruleFormRef7 = ref({});
    const ruleFormRef8 = ref({});
    const code = ref();
    const codeValid = ref();
    const codeLoading = ref(false);
    const freeProduct = ref([]);
    const freeLoading = ref(false);
    const store = useStore();
    var arrayCoord = computed(() => store.state.map.arrayCoord);
    var deliveryPossible = computed(() => store.state.map.deliveryPossible);
    var checkFromSelect = ref(false);
    var fromSelectRestaurant = ref(false);

    // кастомное правило
    const checkNumber = (rule, value, callback) => {
      if (!Number.isInteger(value) && value) {
        callback(new Error("Введите число!"));
      } else {
        if (value <= 0 && value) {
          callback(new Error("Неверное кол-во!"));
        } else {
          callback();
        }
      }
    };

    // получение промокода
    const fetchCode = async () => {
      try {
        codeLoading.value = true;
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/code`);
        code.value = data[0].code;
      } catch (err) {
        console.log(err);
      } finally {
        codeLoading.value = false;
      }
    };

    // получение товаров по промокоду
    const fetchFree = async () => {
      try {
        freeLoading.value = true;
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/items?category=snacks&id=41`);
        freeProduct.value = data.map(obj => ({
          ...obj,
          count: 1
        }));
      } catch (err) {
        console.log(err);
      } finally {
        freeLoading.value = false;
      }
    };
    const checkCode = () => {
      fetchCode().then(() => {
        if (code.value === form.value.code) {
          codeValid.value = true;
          fetchFree();
        } else {
          codeValid.value = false;
        }
      });
    };
    const cancelCode = () => {
      freeProduct.value = [];
      codeValid.value = "";
      form.value.code = "";
    };

    // проверка адреса на доступность для доставки
    const checkGeo = (rule, value, callback) => {
      let possible = false;
      let address = `${props.cityRadio1}, ${value}`;
      store.dispatch("map/geocoderAddress", address).then(() => {
        store.dispatch("map/checkAddress", {
          lat: arrayCoord.value[0],
          long: arrayCoord.value[1]
        }).then(() => {
          possible = deliveryPossible.value;
          if (value && !possible) {
            callback(new Error("Доставка по этому адресу не осуществляется!"));
          } else {
            callback();
          }
        });
      });
    };

    // проверка что адрес был выбран из списка
    const checkSelect = (rule, value, callback) => {
      if (!checkFromSelect.value) {
        callback(new Error("Адрес не выбран!"));
      } else {
        callback();
      }
    };

    // проверка что ресторан был выбран из списка
    const checkRestaurant = (rule, value, callback) => {
      if (!fromSelectRestaurant.value) {
        callback(new Error("Адрес не выбран!"));
      } else {
        callback();
      }
    };
    const rules = ref({
      address: [{
        required: true,
        message: "Нужно заполнить!",
        trigger: "blur"
      }, {
        min: 5,
        message: "Слишком короткий!",
        trigger: "blur"
      }, {
        validator: checkGeo,
        trigger: "submit"
      }, {
        validator: checkSelect,
        trigger: "submit"
      }],
      restaurant: [{
        required: true,
        message: "Нужно заполнить!",
        trigger: "blur"
      }, {
        min: 5,
        message: "Слишком короткий!",
        trigger: "blur"
      }, {
        validator: checkRestaurant,
        trigger: "submit"
      }],
      name: [{
        required: true,
        message: "Нужно заполнить!",
        trigger: "blur"
      }, {
        min: 3,
        message: "Слишком короткий!",
        trigger: "blur"
      }],
      tel: [{
        required: true,
        message: "Нужно заполнить!",
        trigger: "blur"
      }, {
        min: 18,
        message: "Слишком короткий!",
        trigger: "blur"
      }],
      number: [{
        validator: checkNumber,
        trigger: "blur"
      }]
    });
    const onClickAddPlus = item => {
      if (!item.isAdded) {
        addToCart(item);
      } else {
        removeFromCart(item);
      }
    };
    return {
      address,
      form,
      ruleFormRef1,
      ruleFormRef2,
      ruleFormRef3,
      ruleFormRef4,
      ruleFormRef5,
      ruleFormRef6,
      ruleFormRef7,
      ruleFormRef8,
      rules,
      cart,
      onClickAddPlus,
      products,
      totalPrice,
      checkCode,
      codeValid,
      codeLoading,
      freeProduct,
      cancelCode,
      freeLoading,
      historyOrder,
      sushi,
      rolls,
      sets,
      snacks,
      drinks,
      slides,
      favorites,
      categores,
      product,
      slidesTovar,
      area,
      checkFromSelect,
      fromSelectRestaurant
    };
  }
};